import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { collapseRightToolbar } from '../../../../action/right-toolbar-state-actions'
import Wind from '../../../../lib/api/wind'
import Dialog from '../../common/dialog'
import IdealWindDisplay from './ideal-wind-display'
import SetIdealWind from '../../common/hunt-wind/set-ideal-wind'
import DisplayHourly from '../../common/hunt-wind/display-hourly'
import DisplayDaily from '../../common/hunt-wind/display-daily'
import { isNil } from 'lodash'
import { markerUpdateRequest } from '../../../../action/marker-actions'
import SubPopup from '../../common/hunt-wind/sub-popup'
import WindOverlay3D from '../../common/hunt-wind/particle-overlay-3d'
import DeerActivity from '../../common/hunt-wind/deer-activity'

class HuntWindDialog extends Dialog {
  constructor(props) {
    super(props)


    let idealWinds = [];

    try {
      const parsed = JSON.parse(props.rightToolbarState?.data?.extendedData || '{}');
      idealWinds = parsed?.huntStandData?.preferredWindDirections || [];
    } catch (e) {
      idealWinds = [];
    }


    this.state = {
      dataView: 'hourly',
      loading: true,
      editing: false,
      hourlyForcast: [],
      dailyForcast: [],
      idealWinds,
      // idealWinds: JSON.parse(props.rightToolbarState?.data?.extendedData)?.huntStandData?.preferredWindDirections,
      showProModal: false
    }
    this.proWillShow = false
  }

  centerMap(latitude, longitude) {
    const { mapReference, mapReferenceThreed, is3dMapselected } = this.props
    if (is3dMapselected && mapReferenceThreed) {
      mapReferenceThreed.setCenter([longitude, latitude])
      mapReferenceThreed.setZoom(17)
    } else if (mapReference) {
      mapReference.setCenter({ lat: latitude, lng: longitude })
      mapReference.setZoom(17)
    }
  }

  componentDidMount() {
    const { collapseLeftToolbar, rightToolbarState, token } = this.props,
      { fetchHourly, fetchDaily } = Wind,
      { data } = rightToolbarState,
      { latitude, longitude } = data,
      reqObj = { lat: latitude, lng: longitude, token }

    collapseLeftToolbar()
    this.centerMap(latitude, longitude)

    Promise.all([fetchHourly(reqObj), fetchDaily(reqObj)])
      .then(res => {
        this.setState({
          hourlyForcast: res[0],
          dailyForcast: res[1].filter(day => !isNil(day.direction)),
          loading: false
        })
      })
      .catch(err => {
        console.error('Cound not fetch wind data: ', err)
      })
  }

  componentDidUpdate(preProps, prevState) {
    if (preProps.rightToolbarState != this.props.rightToolbarState) {
      this.setState({ idealWinds: JSON.parse(this.props.rightToolbarState.data.extendedData).huntStandData.preferredWindDirections, })
      const { rightToolbarState, token } = this.props,
        { fetchHourly, fetchDaily } = Wind,
        { data } = rightToolbarState,
        { latitude, longitude } = data,
        reqObj = { lat: latitude, lng: longitude, token }
      this.centerMap(latitude, longitude)

      Promise.all([fetchHourly(reqObj), fetchDaily(reqObj)])
        .then(res => {
          this.setState({
            hourlyForcast: res[0],
            dailyForcast: res[1].filter(day => !isNil(day.direction)),
            loading: false
          })
        })
        .catch(err => {
          console.error('Cound not fetch wind data: ', err)
        })
    }
  }
  toggleEditing() {
    this.setState({ editing: !this.state.editing })
  }

  setWinds(winds) {
    this.setState({ idealWinds: winds })
  }

  saveMarker() {
    const { rightToolbarState, markerUpdateRequest } = this.props,
      { idealWinds } = this.state,
      { data } = rightToolbarState,
      markerObj = Object.assign({}, data)
    markerObj['extendedData'] = `{"huntStandData": {"preferredWindDirections": ${JSON.stringify(idealWinds)}}}`
    markerUpdateRequest(markerObj)
      .then(res => {
        this.setState({ editing: false, loading: false })
      })
      .catch(err => {
        console.error('Unable to update ideal wind: ', err)
        this.setState({ loading: false })
      })
  }

  toggleProModal() {
    this.proWillShow = !this.proWillShow
    this.setState({ showProModal: !this.state.showProModal })
  }

  render() {
    const { rightToolbarState, collapseRightToolbar, is3dMapselected } = this.props,
      { data } = rightToolbarState,
      { hourlyForcast, dailyForcast, dataView, loading, idealWinds, editing } = this.state,
      { latitude, longitude } = data,
      overlayComponent = is3dMapselected ? WindOverlay3D : undefined
    return (
      <div className='dialog-content-container hunt-wind-dialog'>
        <div className='hunt-wind-dialog-header'>
          <div style={{ color: 'white' }}>{data.name}</div>
          <div className='default-close' onClick={collapseRightToolbar}></div>
        </div>
        <div className='hunt-wind-dialog-body'>
          <div className='hunt-wind-header'>HuntWind&#8482;</div>
          <div className='hunt-wind-title-icon'></div>
          <div className='hunt-wind-prompt'>
            Hyper accurate wind data to plan your hunt.
          </div>
          <div>
            <IdealWindDisplay idealWinds={idealWinds}
              toggleEditing={this.toggleEditing.bind(this)}
              fromEdit={true} />
          </div>
          {
            !editing ? (
              <div>
                <div className='hunt-wind-data-switch'>
                  <button className='hunt-wind-switch-button' style={{
                    backgroundColor: dataView === 'hourly' ? '#589500' : 'black'
                  }} onClick={() => { this.setState({ dataView: 'hourly' }) }}>24 Hour</button>
                  <button className='hunt-wind-switch-button' style={{
                    backgroundColor: dataView === 'daily' ? '#589500' : 'black'
                  }} onClick={() => { this.setState({ dataView: 'daily' }) }}>7-Day</button>
                </div>
                <div style={{ marginTop: '20px' }}>
                  {
                    !loading ?
                      dataView === 'hourly' ?
                        <DisplayHourly
                          ideal={idealWinds}
                          forcast={hourlyForcast}
                          user={this.props.user}
                          modalVisible={this.proWillShow}
                          toggleProModal={this.toggleProModal.bind(this)}
                          position={{ lat: latitude, lng: longitude }}
                          overlayComponent={overlayComponent} />
                        : <DisplayDaily
                          user={this.props.user}
                          toggleProModal={this.toggleProModal.bind(this)}
                          position={{ lat: latitude, lng: longitude }}
                          ideal={idealWinds}
                          forcast={dailyForcast}
                          overlayComponent={overlayComponent} /> : null
                  }
                </div>
                <DeerActivity latitude={latitude} longitude={longitude} token={this.props.token} />
              </div>) : editing ? <SetIdealWind
                toggleEditing={this.toggleEditing.bind(this)}
                fromEdit={true}
                winds={idealWinds}
                saveMarker={this.saveMarker.bind(this)}
                markerData={data}
                setWinds={this.setWinds.bind(this)} /> : null
          }
        </div>
        {
          this.state.showProModal ? <SubPopup hidePopup={this.toggleProModal.bind(this)} /> : null
        }
      </div >
    )
  }
}

const mapStateToProps = state => ({
  token: state.auth.token,
  mapReference: state.mapReference(),
  mapReferenceThreed: state.mapReferenceThreed,
  is3dMapselected: state.is3dMapselected,
  rightToolbarState: state.rightToolbarState,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  collapseRightToolbar: () => dispatch(collapseRightToolbar()),
  markerUpdateRequest: data => dispatch(markerUpdateRequest(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(HuntWindDialog)